import { render, staticRenderFns } from "./DropdownEditButton.vue?vue&type=template&id=b7bdfb54&"
import script from "./DropdownEditButton.vue?vue&type=script&lang=js&"
export * from "./DropdownEditButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports